import { Component, OnInit } from '@angular/core';
import { UserKycApplicationListItemDto } from '../../../_core/_model/compliance';
import { ComplianceApiService } from '../../../_core/_services/_compliance/compliance-api.service';
import { Router } from '@angular/router';
import { NotificationService } from '../../../_core/_services/notification.service';

@Component({
  selector: 'app-my-kyc-applications',
  standalone: false,
  templateUrl: './my-kyc-applications.html',
  styleUrl: './my-kyc-applications.css',
})
export class MyKycApplications  implements OnInit {
  loading = false;
  applications: UserKycApplicationListItemDto[] = [];
  error: string | null = null;
  deleteBusyId: string | null = null;

  page: number = 1;

  constructor(
      private notifyService: NotificationService,
    private api: ComplianceApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.api.getMyApplications({ page: this.page }).subscribe({
      next: (res) => {
        this.applications = res.data || [];
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.error?.message || 'Failed to load applications';
        this.notifyService.showError(this.error!, 'Error');
        this.loading = false;
      }
    });
  }

  startNew(): void {
    this.loading = true;

    this.api.startApplication().subscribe({
      next: (res) => {
        const app = res.data;
        this.router.navigate(['/compliance/wizard', app.applicationId]);
      },
      error: (err) => {
        this.error = err?.error?.message || 'Failed to start application';
        this.notifyService.showError(this.error!, 'Error');
        this.loading = false;
      }
    });
  }

  open(app: UserKycApplicationListItemDto): void {
    this.router.navigate(['/compliance/applications', app.applicationId]);
  }

  canDelete(item: UserKycApplicationListItemDto): boolean {
    return item.status === 'Draft';
  }

  delete(item: UserKycApplicationListItemDto): void {
    if (!item?.applicationId) return;

    const confirmed = window.confirm('Delete this draft application? This cannot be undone.');
    if (!confirmed) return;

    this.deleteBusyId = item.applicationId;
    this.error = null;

    this.api.deleteApplication(item.applicationId).subscribe({
      next: () => {
        this.deleteBusyId = null;
        this.load();
      },
      error: (err) => {
        this.deleteBusyId = null;
        this.error = err?.error?.message || 'Failed to delete application.';
      }
    });
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Approved': return 'text-bg-success';
      case 'Rejected': return 'text-bg-danger';
      case 'Submitted':
      case 'PendingThirdPartyVerification':
      case 'UnderReview': return 'text-bg-warning';
      default: return 'text-bg-secondary';
    }
  }

  getStatusLabel(status: string): string {
    if (status === 'PendingThirdPartyVerification') {
      return 'Pending Third Party Verification';
    }

    return String(status || '')
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .trim();
  }
}
